<template>
  <div id="app">
    <div v-if="wechatCallbackProcessing" class="wechat-callback-overlay">
      <span>正在处理微信登录...</span>
    </div>
    <router-view v-else />
    <TUICallKit
      :allowed-minimized="false"
      :before-calling="handleTUICallBeforeCalling"
      :after-calling="handleTUICallAfterCalling"
      :status-changed="handleTUICallStatusChanged"
    />
    <!-- 直接在 App 中添加绑定手机弹窗 -->
    <BindPhoneDialog :visible.sync="showBindPhoneDialogInApp" :wx-open-id="bindPhoneWxOpenId" />
  </div>
</template>

<script>
import { getOpenIdByCode } from '@/api/user'
import { mobileThirdLogin } from '@/api/login'
import { TUICallKit } from '@trtc/calls-uikit-vue2'
import { loginIM } from '@/utils/im'
const WX_SCAN_OPENID_KEY = 'wxScanOpenId'
import BindPhoneDialog from '@/components/BindPhoneDialog.vue'
export default {
  components: {
    BindPhoneDialog,
    TUICallKit
  },
  name: 'App',
  data() {
    return {
      wechatCallbackProcessing: false,
      showBindPhoneDialogInApp: false,
      bindPhoneWxOpenId: ''
    }
  },
  mounted() {
    this.handleWechatCallback()
  },
  methods: {
    forceShowTUICallKit() {
      const el = document.getElementById('tuicallkit-id')
      if (!el) return
      el.style.visibility = 'visible'
      el.style.display = 'block'
      el.style.zIndex = '40010'
      el.classList.remove('miniMized')
      el.classList.remove('miniMized-mobile-audio')
      el.classList.remove('miniMized-mobile-video')
    },
    handleTUICallBeforeCalling(...args) {
      console.log('[TUICallKit][beforeCalling]', ...args)
      this.forceShowTUICallKit()
    },
    handleTUICallAfterCalling(...args) {
      console.log('[TUICallKit][afterCalling]', ...args)
      this.forceShowTUICallKit()
    },
    handleTUICallStatusChanged(...args) {
      console.log('[TUICallKit][statusChanged]', ...args)
      // 通话状态切换时兜底强制拉起可见层，避免进入隐藏/浮窗态后界面不显示。
      this.$nextTick(() => {
        this.forceShowTUICallKit()
        setTimeout(() => this.forceShowTUICallKit(), 80)
      })
    },
    getCodeFromUrl() {
      const search = window.location.search || ''
      const hash = window.location.hash || ''
      const fromSearch = search.match(/[?&]code=([^&]+)/)
      const fromHash = hash.match(/[?&]code=([^&]+)/)
      const match = fromSearch || fromHash
      return match ? decodeURIComponent(match[1]) : ''
    },
    async handleWechatCallback() {
      const code = this.getCodeFromUrl()
      console.log('code', code);

      if (!code) return
      // 在 iframe 中或主窗口：扫码回调，用 code 换 openid，交由绑定手机流程写入 unionID
      const isInIframe = window.self !== window.top
      if (!isInIframe) {
        this.wechatCallbackProcessing = true
      }
      try {
        const res = await getOpenIdByCode({ code })
        if (res.code !== 1 || !res.data) {
          throw new Error(res.msg || '获取 openid 失败')
        }
        console.log('res.data', res.data);
        const openid = res.data

        // EXE/弹窗 iframe：回调页在父窗口域名外，通过 postMessage 回传 openid
        if (isInIframe) {
          try {
            sessionStorage.setItem(WX_SCAN_OPENID_KEY, openid)
          } catch (_) { /* ignore */ }
          window.parent.postMessage({ type: 'wechat-scan-success', openid }, '*')
          return
        }

        const data = await mobileThirdLogin({ unionID: openid })
        if (data.code !== 1) {
          throw new Error(data.msg || '获取 openid 失败')
        }
        if (data.data == null) {
          sessionStorage.setItem(WX_SCAN_OPENID_KEY, openid)
          this.bindPhoneWxOpenId = openid
          this.showBindPhoneDialogInApp = true
        } else {
          this.$message.success('登录成功')
          this.$store.commit('user/SET_TOKEN', data.data.token)
          this.$store.commit('user/SET_USER_INFO', data.data.userVo)
          try {
            await loginIM()
          } catch (err) {
            console.warn('[IM] 登录后预登录失败:', err && err.msg)
          }
        }
      } catch (e) {
        console.error('微信登录回调失败:', e)
        if (isInIframe) {
          try {
            window.parent.postMessage({ type: 'wechat-scan-error', message: e?.message || '处理失败' }, '*')
          } catch (_) { /* ignore */ }
        } else if (this.$message && this.$message.error) {
          this.$message.error(e?.message || '处理失败，请重试')
        }
      } finally {
        this.wechatCallbackProcessing = false
        let clean = window.location.pathname + (window.location.hash || '#/')
        clean = clean.replace(/[?&]code=[^&]*/g, '').replace(/[?&]state=[^&]*/g, '').replace(/\?&+|\?$|&$/g, '')
        window.history.replaceState(null, '', clean || '/')
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  width: 100%;
  height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.el-pagination.is-background .el-pager li {
  background: #fff !important;
  border: 1px solid #eee !important;
  color: #333 !important;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #fff6af !important;
  color: #333 !important;
}

.el-pagination.is-background .btn-prev {
  background: none !important;
}

.el-pagination.is-background .btn-next {
  background: none !important;
}

/* 覆盖 common.scss 中 img 的 pointer-events:none，使可点击的图片生效 */
img.clickable {
  pointer-events: auto !important;
  cursor: pointer;
}

.el-range-separator {
  width: 10% !important;
  font-size: 14px !important;
}

/* 全局样式 - 放在 App.vue 的 style 标签中（不加 scoped） */
.el-cascader-panel {
  height: 400px !important;
}

.el-cascader-menu__wrap {
  height: 100% !important;
}

/* 或者更精确地设置 */
.el-cascader__dropdown .el-cascader-panel {
  height: 400px !important;
}

.el-cascader__dropdown .el-cascader-menu {
  height: 100% !important;
}

.el-cascader__dropdown .el-cascader-menu__wrap {
  height: 100% !important;
}

/* 全局禁用 ElementUI 文本域拖拽大小 */
.el-textarea__inner {
  resize: none !important;
}

/* 微信扫码回调处理中 */
.wechat-callback-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-size: 16px;
  color: #333;
}

/* CallKit 兜底层级与可见性，避免被业务弹窗覆盖导致“有呼叫但看不到界面” */
#tuicallkit-id {
  position: fixed !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  width: min(960px, 92vw) !important;
  height: min(680px, 86vh) !important;
  max-width: 960px !important;
  max-height: 680px !important;
  z-index: 40010 !important;
  visibility: visible !important;
  overflow: hidden !important;
  border-radius: 12px !important;
}

.callkit-container,
.tk-call-kit-container,
[class*='callkit-container'] {
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  width: 100% !important;
  height: 100% !important;
  transform: none !important;
  margin: 0 !important;
  z-index: 40010 !important;
}
</style>
